<template>
  <div class="home">
<!--    <nav-bar v-if="!isweixin" title="我的" fixed style="background: #ef4f21;margin-bottom: 39px;" />-->
    <div class="match">
      <homelist :list="homeList" />
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import { getStorage, isWeiXin } from '@/libs/utils'
import { NavBar } from 'vant'
import homelist from '@/components/homelist'

export default {
  name: 'home',
  components: {
    NavBar,
    homelist
  },
  data() {
    return {
      page:1,
      homeList: {},
      isweixin: false
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.isweixin = isWeiXin()
      let userInfo = getStorage('userInfo')
      this.homeList = userInfo
    })

  }
}
</script>
